import { Fragment, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getPageBrowserTabTitleWithEntityName,
  useModals,
  usePageBrowserTabTitle,
} from '../../../hooks'
import { useAsyncEntity } from '../../Entity'
import { EntityPageProfileLayout } from '../../Page'
import { useUserProfileReloadRegistries } from '../User.hooks'
import { UserProfileContextProvider } from '../UserProfileContextProvider'

import { USER_PROFILE_MODALS_CONFIG } from './UserProfile.constants'
import { getUserProfileBrowserTabEntityName } from './UserProfile.utils'

function UserProfile({
  Header,
  Loader,
  Tabs,
  actionsWidget,
  browserTabTitleKey,
  getBrowserTabEntityName = getUserProfileBrowserTabEntityName,
  getBrowserTabTitleKey,
  getProfileData,
  prepareData,
  qaName,
  updateProfileData,
  widgets,
}) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)
  const [isPerformingAction, setPerformingAction] = useState(false)

  const pageScrollWrapperRef = useRef(null)

  function handleCloseModal() {
    setModal(null)
  }

  const { closeEmailFormModal, modals, setEmailFormModal } = useModals(
    USER_PROFILE_MODALS_CONFIG
  )

  const {
    entityData,
    handleEntityReload,
    handleUpdateEntity,
    isInitiated,
    isLoading,
    serverError,
  } = useAsyncEntity({
    getProfileData,
    updateProfileData,
  })

  const {
    handleReloadTabs,
    registerBuildingsTabReload,
    registerCategoriesTabReload,
    registerContractsTabReload,
    registerDocumentsTabReload,
    registerEmailsTabReload,
    registerRequestsTabReload,
    registerTabCountersReload,
  } = useUserProfileReloadRegistries()

  const userData = prepareData(entityData)

  usePageBrowserTabTitle({
    isLoading: !isInitiated,
    pageTitle: getPageBrowserTabTitleWithEntityName({
      name: getBrowserTabEntityName(userData),
      title: t(getBrowserTabTitleKey?.(userData) ?? browserTabTitleKey),
    }),
  })

  return (
    <UserProfileContextProvider
      closeEmailFormModal={closeEmailFormModal}
      handleCloseModal={handleCloseModal}
      handleEntityReload={handleEntityReload}
      handleReloadTabs={handleReloadTabs}
      handleUpdateEntity={handleUpdateEntity}
      isInitiated={isInitiated}
      isLoading={isLoading}
      isPerformingAction={isPerformingAction}
      registerBuildingsTabReload={registerBuildingsTabReload}
      registerCategoriesTabReload={registerCategoriesTabReload}
      registerContractsTabReload={registerContractsTabReload}
      registerDocumentsTabReload={registerDocumentsTabReload}
      registerEmailsTabReload={registerEmailsTabReload}
      registerRequestsTabReload={registerRequestsTabReload}
      registerTabCountersReload={registerTabCountersReload}
      setEmailFormModal={setEmailFormModal}
      setModal={setModal}
      setPerformingAction={setPerformingAction}
      userData={userData}
    >
      <EntityPageProfileLayout
        Header={Header}
        Loader={Loader}
        actionsWidget={actionsWidget}
        qaName={qaName}
        scrollWrapperRef={pageScrollWrapperRef}
        serverError={serverError}
        widgets={widgets}
      >
        {Tabs ? <Tabs userData={userData} /> : null}
        {modal}
        {modals.map(([id, element]) => (
          <Fragment key={id}>{element}</Fragment>
        ))}
      </EntityPageProfileLayout>
    </UserProfileContextProvider>
  )
}

export default UserProfile
